import { EditorState } from "draft-js";

export const moveFocusToEnd = (editorState: EditorState) => {
  editorState = EditorState.moveSelectionToEnd(editorState);
  return EditorState.forceSelection(editorState, editorState.getSelection());
};